import TemplateView from '../../../TemplateView'

const LongTimeMs = 30000

export default class BulkOperationProgress extends TemplateView {
    constructor() {
        super()

        this.state = {
            progress: 0,
            longTimeWarningShown: false
        }

        this.onStatePropertyChanged('progress', (progress, oldProgress) => {
            if (progress === null) {
                this.setState({longTimePassed: false})
                setTimeout(() => {
                    this.setState({longTimePassed: true})
                }, LongTimeMs)
            }
            this.$completedLabel.toggle(!!progress && progress > 0)
            this.$percent.text(!!progress && progress > 0 ? `${progress} %` : '')
            if (!!progress && progress > 0) {
                this.$longProgress.hide()
            }
        })

        this.onStatePropertyChanged('longTimePassed', (longTimePassed) => {
            if (!longTimePassed) {
                this.$longProgress.hide()
            }
            if (longTimePassed && !this.state.progress) {
                this.$longProgress.show()
            }
        })
    }

    afterRender() {
        this.$percent = this.find('.percents')
        this.$completedLabel = this.find('.completedLabel')
        this.$longProgress = this.find('.longProgress')
    }

    templateHtml() {
        return '<div class="bulkOperationProgress">' +
               '    <span class="percents"></span>' +
               '    <span class="completedLabel"><%=completed%></span>' +
               '    <span class="longProgress"><%=longProgress%></span>' +
               '</div>'
    }

    messageKeys() {
        return {
            completed: 'task.list.bulk_operations.progress.completed',
            longProgress: 'task.list.bulk_operations.progress.long'
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/components/BulkOperationProgress.js